import { connect } from 'react-redux';
import RequestPasswordResetComponent from '../components/RequestPasswordResetComponent';
import { requestPasswordReset } from '../actions/ProfileActions';

const mapStateToProps = (state) => ({
    submitting: state.profile.submitting,
    passwordResetRequested: state.profile.passwordResetRequested,
});

const mapDispatchToProps = (dispatch) => ({
    requestPasswordReset: (email) => {
        dispatch(requestPasswordReset(email));
    },
});

const RequestPasswordResetContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(RequestPasswordResetComponent);

export default RequestPasswordResetContainer;
